import Cluster from './Cluster.svg';
import BelhavenCuster from './clusters/Belhaven-cluster.svg';
import CraftedCluster from './clusters/Crafted-cluster.svg';
import ChefBrewerCluster from './clusters/ChefBrewer-cluster.svg';
import FarmhouseInnsCluster from './clusters/FarmhouseInns-cluster.svg';
import FarmhouseKitchenCluster from './clusters/FarmhouseKitchen-cluster.svg';
import GreeneKingCluster from './clusters/GreeneKing-cluster.svg';
import HungryHorseCluster from './clusters/HungryHorse-cluster.svg';
import MetroCluster from './clusters/Metro-cluster.svg';
import EverlyCluster from './clusters/Everly-cluster.svg';
import FlamingGrillCluster from './clusters/FlamingGrill-cluster.svg';
import DefaultCluster from './clusters/default-cluster.svg';
import DefaultNotSelected from './not-selected/default.svg';
import DefaultSelected from './selected/default.svg';
import DefaultHover from './hover/default.svg';

const pins = {
  Belhaven: {
    cluster: BelhavenCuster,
  },
  ChefBrewer: {
    cluster: ChefBrewerCluster,
  },
  FarmhouseInns: {
    cluster: FarmhouseInnsCluster,
  },
  FarmhouseKitchen: {
    cluster: FarmhouseKitchenCluster,
  },
  GreeneKing: {
    cluster: GreeneKingCluster,
  },
  HungryHorse: {
    cluster: HungryHorseCluster,
  },
  Metro: {
    cluster: MetroCluster,
  },
  Crafted: {
    cluster: CraftedCluster,
  },
  WackyWarehouse: {
    cluster: DefaultCluster,
  },
  Everly: {
    cluster: EverlyCluster,
  },
  FlamingGrill: {
    cluster: FlamingGrillCluster,
  },
  default: {
    mapPinIconNormal: DefaultNotSelected,
    mapPinIconSelected: DefaultSelected,
    mapPinIconHover: DefaultHover,
    cluster: DefaultCluster,
  },
  Cluster: Cluster,
};

const brandNamesMap = {
  Belhaven: ['Belhaven', 'BelhavenPubs'],
  ChefBrewer: ['ChefBrewer', 'ChefAndBrewer'],
  FarmhouseInns: ['FarmhouseInns'],
  FarmhouseKitchen: ['FarmhouseKitchen'],
  GreeneKing: ['GreeneKing'],
  GreeneKingInns: ['GreeneKingInns'],
  HungryHorse: ['HungryHorse'],
  Metro: ['Metro'],
  Crafted: ['Crafted', 'CraftedPubs'],
  WackyWarehouse: ['WackyWarehouse'],
  Everly: ['Everly'],
  FlamingGrill: ['FlamingGrill'],
};

const pickPinIcons = (brandName) => {
  const pinNameByBrand = Object.entries(brandNamesMap).find(([, brands]) =>
    brands.includes(brandName)
  )?.[0];
  return pins[pinNameByBrand] ?? pins['default'];
};

export default pickPinIcons;
